// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileFeed-cls1_Bba","cls2":"ProfileFeed-cls2_XG3 ProfileFeed-cls1_Bba"};